module.exports = __webpack_public_path__ + "static/media/ico-tarjeta_0000_cabal.67ac6eef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/checkout/payment-options/ico-tarjeta_0000_cabal.jpg
// module id = 122
// module chunks = 0